import { TransactionalSaleFormTabId, TransactionalSaleFormTabs } from "./index";

export const MobileTransactionalCreateSaleModalTabOrder: TransactionalSaleFormTabId[] =
  [
    TransactionalSaleFormTabs.WHEN,
    TransactionalSaleFormTabs.WHO,
    TransactionalSaleFormTabs.WHAT,
    TransactionalSaleFormTabs.PRICE,
    TransactionalSaleFormTabs.REVIEW,
  ];
